import request from '@/router/axios';

// 查询典型参数信息列表
export const selectEquipTypicalParamInfoList = () => {
  return request({
    url: '/svolt-ess-boss-service/equipTypicalParamInfo/selectEquipTypicalParamInfoList',
    method: 'get',
  })
};

// 根据设备类型查询典型参数   equipType
export const getEquipTypicalParamListByEquipType = (data) => {
  return request({
    url: '/svolt-ess-boss-service/equipTypicalParamInfo/getEquipTypicalParamListByEquipType',
    method: 'get',
    params: data
  })
};

// 修改典型参数数据点信息    id、tyDPDesc、tyDPName
export const updateEquipTypicalParamInfoList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/equipTypicalParamInfo/updateEquipTypicalParamInfoList',
    method: 'post',
    data: data
  })
};

// 根据设备类型导出典型参数   equipType
export const exportEquipTypicalParamListByEquipType = (data) => {
  return request({
    url: '/svolt-ess-boss-service/equipTypicalParamInfo/exportEquipTypicalParamListByEquipType',
    method: 'get',
    params: data,
    responseType: "blob",
  })
};

// 根据设备类型导入典型参数   userId、equipType、file
export const importEquipTypicalParamListByEquipType = (data) => {
  return request({
    url: '/svolt-ess-boss-service/equipTypicalParamInfo/importEquipTypicalParamListByEquipType',
    method: 'post',
    data: data,
  })
};

export default {
  selectEquipTypicalParamInfoList,
  getEquipTypicalParamListByEquipType,
  updateEquipTypicalParamInfoList,
  exportEquipTypicalParamListByEquipType,
  importEquipTypicalParamListByEquipType
}



// WEBPACK FOOTER //
// ./src/api/typicalParam.js